import React from 'react';
import { useQuery } from 'react-fetching-library';
import Page from '../../components/Page';
import { Card, CardContent } from '@mui/material';
import AddDocument from '../../sections/employee/generics/work-standard/AddDocument';
import WorkStandardList from '../../sections/employee/generics/work-standard/WorkStandardList';

import { getWorkStandardsAction, downloadWorkStandardAction, deleteWorkStandardAction, submitWorkStandardAction } from '../../services/request';

export default function WorkStandard () {
  const [search, setSearch] = React.useState(null);
  const [documents, setDocuments] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [count, setCount] = React.useState(0);
  const { loading, payload, error, query } = useQuery(getWorkStandardsAction('GET', search, page, pageSize));

  const queryCallback = data => {
    setSearch(data.search);
    query('GET', search, data.page, pageSize);
  };

  React.useEffect(() => {
    if (!loading && !error) {
      setDocuments(payload.results);
      setCount(payload.count);
    }
  }, [loading]);

  return (
    <Page title="Standardy pracy">
      <Card>
        <CardContent>
          <>
            <AddDocument setDocuments={setDocuments} submitDocumentAction={submitWorkStandardAction} getDocumentsAction={getWorkStandardsAction} setCount={setCount} />
            <WorkStandardList
              documents={documents}
              queryCallback={queryCallback}
              setDocuments={setDocuments}
              downloadDocumentAction={downloadWorkStandardAction}
              deleteDocumentAction={deleteWorkStandardAction}
              submitDocumentAction={submitWorkStandardAction}
              getDocumentsAction={getWorkStandardsAction}
              page={page}
              setPage={setPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
              count={count}
              setCount={setCount}
            />
          </>
        </CardContent>
      </Card>
    </Page>
  );
};
